import { Form, Input } from 'antd';
import PropTypes from 'prop-types';
import './VialidadesRecorridas.scss';
import * as fieldMsgs from 'constants/formFieldsMessages';

const VialidadesRecorridas = ({ form }) => {
  return (
    <div>
      <Form form={form} layout="vertical">
        <div>
          <Form.Item
            name="recorrido"
            label="Recorrido:"
            rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
            <Input.TextArea rows={8} showCount maxLength={5000} placeholder="Escribe" />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default VialidadesRecorridas;

VialidadesRecorridas.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired
};
